import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import IconLoader from '../../../IconLoader';
import { AverageStrideLengthCardData } from './AverageStrideLengthCardData';

import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ReactComponent as Background } from './averageStrideLengthBackground.svg';

interface AverageStrideLengthCardMiniProps {
  data?: AverageStrideLengthCardData;
}

const ParamHeader = styled(Typography)(() => ({
  display: 'inline',
  border: '1px solid',
  borderRadius: '16px',
  padding: '3px',
  margin: '10px',
}));

const ParamHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

const ParamContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
}));

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  fontWeight: 'bold',
  textAlign: 'center',
}));

const AverageStrideLengthCardMini: React.FC<
  AverageStrideLengthCardMiniProps
> = ({ data }: AverageStrideLengthCardMiniProps) => {
  const { t } = useTranslation('cards');
  return (
    <Box
      sx={{
        height: '154px',
        width: '265px',
        direction: 'column',
        alignItems: 'center',
      }}
    >
      <ParamHeaderContainer>
        <IconLoader name="AverageStrideLength" fill="black" />
        <Typography
          sx={{
            ml: 2,
          }}
          variant="h5"
          component="h2"
        >
          <ParamHeader>{t('averageStrideLengthMini.title')}</ParamHeader>
        </Typography>
      </ParamHeaderContainer>
      <ParamContentContainer>
        {isEmpty(data?.left.length) && isEmpty(data?.right.length) ? (
          <Grid
            sx={{
              position: 'relative',
              height: '100px',
              width: '180px',
              margin: '5px 32px 0px 0px',
            }}
            container
          >
            <Background
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 1,
              }}
            />
            <Grid

              sx={{
                position: 'absolute',
                top: '25px',
                left: '15px',
                width: '86.5px',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 2,
              }}
            >
              <CardDetailTypography>
                {data ? Number(data.left.length) : 0}
              </CardDetailTypography>
              <CardDetailTypography>
                {data ? data.unit : 's'}
              </CardDetailTypography>
            </Grid>
            <Grid

              sx={{
                position: 'absolute',
                top: '25px',
                left: '80px',
                width: '86.5px',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 2,
              }}
            >
              <CardDetailTypography>
                {data ? Number(data.right.length) : 0}
              </CardDetailTypography>
              <CardDetailTypography>
                {data ? data.unit : 's'}
              </CardDetailTypography>
            </Grid>
          </Grid>
        ) : null}
      </ParamContentContainer>
    </Box>
  );
};

export default AverageStrideLengthCardMini;
